import { LAYOUT_TYPE } from '@sbercloud/uikit-product-utils';

export const SERVER_DATA_HEADERS = {
  xLayoutType: 'x-layout-type',
};

export const SERVER_DATA_LAYOUT_TYPE_FALLBACK_VALUE = LAYOUT_TYPE.Mobile;
